import React from 'react';
import {SummaryContext} from './summary';

function useSummary() {
  const context = React.useContext(SummaryContext);
  if (context === undefined) {
    throw new Error('useSummary must be used within a SummaryProvider');
  }
  return context;
}

export {useSummary};
